import React, { useEffect, useRef, useState } from 'react'
import {
    Box,
    Text,

    /* Hooks */
    useMultiStyleConfig
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

const HeroSliderCustomNavigation = ({
    nextTitle,
    handleNextSlide,
    handlePrevSlide,
    noAutoplay = true,
    currentTitleColor,
    fadeClass = 'fade-in',
    ...props
}) => {
    const styles = useMultiStyleConfig('HeroPanelBlock', { ...props, currentTitleColor: currentTitleColor })
    const intl = useIntl()
    const paginationLineRef = useRef(null)
    const staticContent = {
        nextUp: intl.formatMessage({
            id: 'cms.CarouselCtaBlock.nex_up',
            defaultMessage: 'Next Up'
        })
    }

    const arrow = () => {
        return `<svg class="custom-arrow" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24.3335 16L7.66683 16M7.66683 16L14.296 22.6291M7.66683 16L14.296 9.37082" stroke="${currentTitleColor || 'black'}" stroke-width="0.833333" stroke-linecap="square"/>
        </svg>
        `
    }

    const separator = () => {
        return `<svg class="custom-arrow" width="1" height="20" viewBox="0 0 1 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="0.5" y1="2.18557e-08" x2="0.499999" y2="20" stroke="${currentTitleColor || 'black'}"/>
        </svg>`
    }

    useEffect(() => {
        paginationLineRef?.current?.style.setProperty('--progressColor', `${currentTitleColor || 'black'}`)
    }, [currentTitleColor])

    useEffect(() => {
        if (!document.querySelector('#navigation-fade-styles')) {
            const style = document.createElement('style')
            style.id = 'navigation-fade-styles'
            style.textContent = `
                .navigation-title {
                    opacity: 0;
                    transition: opacity 1s ease-in-out;
                }
                .navigation-title.fade-out {
                    opacity: 0;
                }
                .navigation-title.fade-in {
                    opacity: 1;
                }
            `
            document.head.appendChild(style)
        }
    }, [])

    return (
        <Box {...styles.customNavigation}>
            <Text {...styles.nextUp}>
                {staticContent.nextUp}
            </Text>
            <Box {...styles.titleAndControls}>
                <Text {...styles.nextTitle} className={`navigation-title ${fadeClass}`}>
                    {nextTitle}
                </Text>
                <Box {...styles.controlsWrapper}>
                    <Box {...styles.leftArrow}
                        dangerouslySetInnerHTML={{ __html: arrow() }}
                        sx={styles.arrow}
                        onClick={handlePrevSlide}
                        onKeyDown={(e) => e.key === 'Enter' && handlePrevSlide?.(e)}
                        role="button"
                        tabIndex={0}
                        aria-label="Previous slide"></Box>
                    <Box dangerouslySetInnerHTML={{ __html: separator() }}></Box>
                    <Box {...styles.rightArrow}
                        dangerouslySetInnerHTML={{ __html: arrow() }}
                        sx={styles.arrow}
                        onClick={handleNextSlide}
                        onKeyDown={(e) => e.key === 'Enter' && handleNextSlide?.(e)}
                        role="button"
                        tabIndex={0}
                        aria-label="Next slide"></Box>
                </Box>
            </Box>
            {!noAutoplay &&
                <Box ref={paginationLineRef} className="custom-pagination-line"></Box>
            }
        </Box>
    )
}

HeroSliderCustomNavigation.propTypes = {
    nextTitle: PropTypes.string,
    handleNextSlide: PropTypes.func,
    handlePrevSlide: PropTypes.func
}

export default HeroSliderCustomNavigation
